<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div>
<svg height="99%" preserveaspectratio="xMidYMid meet" version="1.1" viewbox="0 0 600 948" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image height="948" style="max-width:100%; max-height:100%" width="600" xlink:href="../data/content-0001.jpg"></image></svg><div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PP1.w.0.0.0.1"></a><a id="GBS.PP1.w.0.0.0.2"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA1"></a>
<a id="GBS.PP1.w.0.0.0.3"></a><img alt="Image for page 2" src="data/content-0002.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.0.0.0.4"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA3"></a>
<a id="GBS.PP1.w.0.0.0.5"></a><img alt="Image for page 4" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.0.0.0.6"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA4"></a>
<a id="GBS.PP1.w.0.0.0.7"></a><img alt="Image for page 5" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.0.0.0.8"></a></div>
<div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PA5"></a>
</div>
<div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PP1.w.0.0.0.9"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0005.vue?49eaf7ea